package com.shadowings.gero.domain.model

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class PhoneticKeyboardContent @OptIn(ExperimentalUuidApi::class) constructor(
    val sentence: String,
    val reading: List<String>,
    val info: String,
    override val id: String = Uuid.random().toHexDashString(),
    val isProperName: Boolean = false,
    val canRotate: Boolean = true,
) : IQuizContent, ICountableQuiz

